import { overrideOptional } from '@emico/overrides'

import ChevronLeftIcon from './ChevronLeftIcon'

const PreviousArrowIcon = overrideOptional(ChevronLeftIcon)

export default PreviousArrowIcon
